export default __webpack_public_path__ + "static/media/nurses-at-work.6f93a42f.png";